module.exports = __webpack_public_path__ + "img/menu_driving_report_green.b9b14c65.svg";